import { StyleSheet, Font } from '@react-pdf/renderer';
import RobotoRegular from '../../../../lib/fonts/Roboto-Regular.ttf';
import RobotoBold from '../../../../lib/fonts/Roboto-Bold.ttf';

Font.register({
  family: 'Roboto',
  fonts: [
    { src: RobotoRegular, fontWeight: 'normal' },
    { src: RobotoBold, fontWeight: 'bold' },
  ],
});

const CORES = {
  azul: '#182856',
  azulSecundario: '#293B6C',
  azulClaro: '#EDF2FA',
  cinza: '#65718A',
  linha: '#C7D0DE',
  texto: '#263550',
  fundoAlternado: '#F6F8FC',
  verdeFundo: '#E8F5EC',
  verde: '#176B3B',
};

export const styles = StyleSheet.create({
  page: {
    paddingTop: 22,
    paddingLeft: 23,
    paddingRight: 23,
    paddingBottom: 35,
    fontFamily: 'Roboto',
    fontSize: 7.4,
    color: CORES.texto,
    backgroundColor: '#FFFFFF',
  },
  cabecalho: { marginBottom: 12 },
  cabecalhoSuperior: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 43,
    marginBottom: 6,
  },
  logoArea: { width: '13%', justifyContent: 'center' },
  logo: { maxWidth: 85, maxHeight: 36, objectFit: 'contain' },
  logoSubstituto: { fontSize: 12, fontWeight: 'bold', color: CORES.azul },
  tituloArea: { width: '71%', paddingHorizontal: 8 },
  titulo: { fontSize: 14, fontWeight: 'bold', color: CORES.azul },
  subtitulo: { fontSize: 7, color: CORES.cinza, marginTop: 4 },
  dataArea: { width: '16%', fontSize: 7, alignItems: 'flex-end', lineHeight: 1.45 },
  faixaDados: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#F0F3F8',
    paddingVertical: 7,
    paddingHorizontal: 10,
    borderRadius: 3,
    color: CORES.texto,
  },
  aberturaGrupo: {
    marginBottom: 9,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tituloSecao: { fontSize: 9.2, fontWeight: 'bold', color: CORES.azul },
  contadorSecao: { fontSize: 7, color: CORES.cinza },
  mapaTabela: { borderLeftWidth: 0.8, borderTopWidth: 0.8, borderColor: CORES.linha },
  cabecalhoTabela: {
    flexDirection: 'row',
    minHeight: 43,
    backgroundColor: CORES.azulSecundario,
    color: '#FFFFFF',
  },
  celulaHeader: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingHorizontal: 8,
    borderRightWidth: 0.8,
    borderBottomWidth: 0.8,
    borderColor: CORES.linha,
    justifyContent: 'center',
  },
  labelHeader: { fontSize: 8, fontWeight: 'bold' },
  headerSub: { fontSize: 6.5, marginTop: 3, color: '#E0E8F5' },
  nomeFornecedor: { fontSize: 7.2, fontWeight: 'bold', lineHeight: 1.25 },
  linhaProduto: { flexDirection: 'row', minHeight: 67 },
  linhaAlternada: { backgroundColor: CORES.fundoAlternado },
  celulaConteudo: {
    flexGrow: 0,
    flexShrink: 0,
    paddingVertical: 7,
    paddingHorizontal: 8,
    borderRightWidth: 0.8,
    borderBottomWidth: 0.8,
    borderColor: CORES.linha,
  },
  celulaOferta: {
    paddingVertical: 7,
    paddingHorizontal: 8,
  },
  ofertaContainer: {
    flexGrow: 0,
    flexShrink: 0,
    borderRightWidth: 0.8,
    borderBottomWidth: 0.8,
    borderColor: CORES.linha,
  },
  celulaSelecionada: { backgroundColor: CORES.verdeFundo },
  codigoProduto: { fontWeight: 'bold', fontSize: 7.1, color: '#3157A0', marginBottom: 3 },
  descricaoProduto: { fontSize: 7.5, lineHeight: 1.23, fontWeight: 'bold', marginBottom: 3 },
  produtoComplemento: { fontSize: 6.7, color: CORES.cinza, marginTop: 2 },
  quantidade: { fontWeight: 'bold', fontSize: 8.2, marginBottom: 11 },
  miniLabel: { fontSize: 6, fontWeight: 'bold', color: CORES.cinza, marginBottom: 3 },
  dataNecessidade: { fontSize: 7.2 },
  precoRow: { flexDirection: 'row', marginBottom: 7 },
  precoHalf: { width: '50%' },
  valorUnitario: { fontSize: 8.3, fontWeight: 'bold', color: '#3157A0' },
  valorTotal: { fontSize: 8.3, fontWeight: 'bold', color: CORES.azul },
  indicadorSelecionado: { color: CORES.verde, fontSize: 6, fontWeight: 'bold', marginBottom: 4 },
  linhaInformacao: { fontSize: 7, marginTop: 1 },
  linhaDiscreta: { fontSize: 6.5, color: CORES.cinza, marginTop: 4, lineHeight: 1.25 },
  linhaObservacao: { fontSize: 6.6, color: CORES.texto, marginTop: 4, lineHeight: 1.25 },
  linhaDocumento: { fontWeight: 'bold', color: CORES.verde, fontSize: 6.7, marginTop: 4 },
  naoRespondido: { color: '#A05F28', fontSize: 6.5, marginTop: 4 },
  semOferta: { color: CORES.cinza, fontStyle: 'italic' },
  resumoTabela: {
    width: '100%',
    borderLeftWidth: 0.8,
    borderTopWidth: 0.8,
    borderColor: CORES.linha,
  },
  resumoTabelaCabecalho: {
    flexDirection: 'row',
    backgroundColor: CORES.azulSecundario,
    color: '#FFFFFF',
  },
  resumoCabecalhoCelula: {
    justifyContent: 'center',
    paddingHorizontal: 8,
    paddingVertical: 9,
    fontSize: 7,
    fontWeight: 'bold',
    borderRightWidth: 0.8,
    borderBottomWidth: 0.8,
    borderColor: CORES.linha,
  },
  resumoTabelaLinha: {
    flexDirection: 'row',
    minHeight: 36,
  },
  resumoTabelaLinhaAlternada: { backgroundColor: CORES.fundoAlternado },
  resumoCelula: {
    justifyContent: 'center',
    paddingHorizontal: 8,
    paddingVertical: 7,
    borderRightWidth: 0.8,
    borderBottomWidth: 0.8,
    borderColor: CORES.linha,
    fontSize: 7.3,
  },
  resumoNome: {
    fontSize: 7.4,
    fontWeight: 'bold',
    color: CORES.azul,
    marginBottom: 4,
  },
  resumoCnpj: { fontSize: 6.7, color: CORES.cinza },
  resumoTotal: { fontSize: 8, fontWeight: 'bold', color: CORES.azul },
  resumoLegenda: { fontSize: 6.6, color: CORES.cinza, marginTop: 9 },
  resumoVazio: { padding: 12, color: CORES.cinza },
  blocoDetalhe: { borderWidth: 0.8, borderColor: CORES.linha, borderRadius: 3, padding: 12 },
  detalheFornecedor: { fontSize: 11, fontWeight: 'bold', color: CORES.azul, marginBottom: 3 },
  detalheCnpj: { fontSize: 7.5, color: CORES.cinza, marginBottom: 12 },
  detalheSecao: { marginBottom: 10 },
  detalheTitulo: {
    fontSize: 8,
    color: CORES.azulSecundario,
    fontWeight: 'bold',
    paddingBottom: 4,
    marginBottom: 4,
    borderBottomWidth: 0.6,
    borderBottomColor: CORES.linha,
  },
  detalheTexto: { fontSize: 7.7, lineHeight: 1.4 },
  rodape: {
    position: 'absolute',
    bottom: 12,
    left: 23,
    right: 23,
    paddingTop: 5,
    borderTopWidth: 0.8,
    borderTopColor: CORES.linha,
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: CORES.cinza,
    fontSize: 6.5,
  },
});
